// src/components/pages/LabsCarousel.jsx  (adjust the import path if needed)
import React, { useMemo } from 'react';
import CrossfadeCarousel from './CrossfadeCarousel';

export default function LabsCarousel() {
  const slides = useMemo(
    () => [
      { src: `${process.env.PUBLIC_URL}/images/labs/labs top carousel/labs 1.1.jpg`, alt: 'Labs 1.1' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs top carousel/labs 1.2.jpg`, alt: 'Labs 1.2' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs top carousel/labs 1.3.jpg`, alt: 'Labs 1.3' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs top carousel/labs 1.4.jpg`, alt: 'Labs 1.4' },
      { src: `${process.env.PUBLIC_URL}/images/labs/labs top carousel/labs 1.5.jpg`, alt: 'Labs 1.5' },
    ],
    []
  );

  return (
    <CrossfadeCarousel
      slides={slides}
    />
  );
}
